/*!
 * KoliBri - The accessible HTML-Standard
 */
import { r as registerInstance, h, g as getElement } from './index-C_ZKddLG.js';
import { _ as __decorate } from './tslib.es6-QNbPBOk5.js';
import { B as BaseWebComponent } from './base-web-component-D909Fl-Y.js';
import { l as linkPropsConfig, a as accessKeyProp, b as ariaControlsProp, c as ariaCurrentValueProp, d as ariaDescriptionProp, e as ariaExpandedProp, n as ariaOwnsProp, o as customClassProp, f as disabledProp, g as downloadProp, h as hideLabelProp, s as spanIconsProp, i as inlineProp, j as linkCallbacksProp, p as linkRoleProp, k as shortKeyProp, q as tabIndexProp, m as linkTargetProp, v as variantProp, t as tooltipAlignProp, L as LinkFC } from './component-BDS_iE5Q.js';
import { T as TooltipBehavior } from './behavior-Co00uT-D.js';
import { t as setEventTarget } from './common-D-vggmh2.js';
import { h as hrefProp } from './href-B7u09W3s.js';
import { l as labelWithExpertSlotProp } from './label-with-expert-slot-CU-oeLnm.js';
import './variant-quote-ClYWonZq.js';
import { v as validateAccessAndShortKey } from './access-and-short-key-ijzCZfHm.js';
import { n as nonce } from './dev.utils-Cib2ENyx.js';
import { b as directFocus, e as directClick, c as createCtaRef } from './element-interaction-C5-6aPzz.js';
import { d as dispatchDomEvent, K as KolEvent } from './events-BhfZTW2e.js';
import { o as onLocationChange } from './ariaCurrentService-YoLNpD5S.js';
import './normalizers-BNeak4hj.js';
import './_Uint8Array-kJHDjtoP.js';
import './isArray-CcrBs4JM.js';
import './align-C8fl12z_.js';
import './i18n-CvFPh0g5.js';
import './i18n-C73LqPIs.js';
import './variant-class-name-9qZ5egaq.js';
import './clsx-COFh-Vc8.js';
import './bem-registry-3ondDImf.js';
import './component-BjVFpeYY.js';
import './component-DepnuZGT.js';
import './component-BXCnkVUN.js';
import './align-floating-elements-CBhVmYjn.js';
import './tooltip-open-tracking-D3tCiiGP.js';
import './label-FtX-skKy.js';
import './label-w3T7Y2ih.js';
import './element-focus-BQXzaLL9.js';

const KolLinkWc = class extends BaseWebComponent {
    constructor(hostRef) {
        super();
        registerInstance(this, hostRef);
        this.ctaRef = createCtaRef();
        this.tooltipBehavior = new TooltipBehavior(this.stateAccess);
        this.handleAnchorClick = (event) => {
            this.tooltipBehavior.hideTooltip();
            const disabled = this.getRenderProp('disabled');
            if (disabled === true) {
                event.preventDefault();
                return;
            }
            const href = this.getRenderProp('href');
            const on = this.getRenderProp('on');
            if (typeof (on === null || on === void 0 ? void 0 : on.onClick) === 'function') {
                setEventTarget(event, this.ctaRef.el);
                on.onClick(event, href);
            }
            if (this.host) {
                dispatchDomEvent(this.host, KolEvent.click, href);
            }
        };
        this.setAnchorRef = (el) => {
            this.ctaRef(el);
        };
        this.ariaCurrent = '';
        this.ariaDescriptionId = nonce();
        this.expertSlot = false;
        this._disabled = false;
        this._hideLabel = false;
        this._inline = true;
        this._tooltipAlign = 'right';
    }
    componentWillLoad() {
        this.initRenderProps(linkPropsConfig);
        this.setRenderProp('tabIndex', undefined);
        accessKeyProp.apply(this._accessKey, (v) => this.setRenderProp('accessKey', v));
        ariaControlsProp.apply(this._ariaControls, (v) => this.setRenderProp('ariaControls', v));
        ariaCurrentValueProp.apply(this._ariaCurrentValue, (v) => this.setRenderProp('ariaCurrentValue', v));
        ariaDescriptionProp.apply(this._ariaDescription, (v) => this.setRenderProp('ariaDescription', v));
        ariaExpandedProp.apply(this._ariaExpanded, (v) => this.setRenderProp('ariaExpanded', v));
        ariaOwnsProp.apply(this._ariaOwns, (v) => this.setRenderProp('ariaOwns', v));
        customClassProp.apply(this._customClass, (v) => this.setRenderProp('customClass', v));
        disabledProp.apply(this._disabled, (v) => this.setRenderProp('disabled', v));
        downloadProp.apply(this._download, (v) => this.setRenderProp('download', v));
        hideLabelProp.apply(this._hideLabel, (v) => this.setRenderProp('hideLabel', v));
        hrefProp.apply(this._href, (v) => this.setRenderProp('href', v));
        spanIconsProp.apply(this._icons, (v) => this.setRenderProp('icons', v));
        inlineProp.apply(this._inline, (v) => this.setRenderProp('inline', v));
        this.applyLabel(this._label);
        linkCallbacksProp.apply(this._on, (v) => this.setRenderProp('on', v));
        linkRoleProp.apply(this._role, (v) => this.setRenderProp('role', v));
        shortKeyProp.apply(this._shortKey, (v) => this.setRenderProp('shortKey', v));
        if (typeof this._tabIndex === 'number') {
            tabIndexProp.apply(this._tabIndex, (v) => this.setRenderProp('tabIndex', v));
        }
        linkTargetProp.apply(this._target, (v) => this.setRenderProp('target', v));
        this.applyTooltipAlign(this._tooltipAlign);
        variantProp.apply(this._variant, (v) => this.setRenderProp('variant', v));
        validateAccessAndShortKey(this._accessKey, this._shortKey);
        this.unsubscribeOnLocationChange = onLocationChange((location) => {
            const href = this.getRenderProp('href');
            const ariaCurrentValue = this.getRenderProp('ariaCurrentValue');
            const newValue = location === href ? ariaCurrentValue : '';
            if (this.getState('ariaCurrent') !== newValue) {
                this.setState('ariaCurrent', newValue);
            }
        });
        this.tooltipBehavior.componentWillLoad({
            label: this.getTooltipLabel(),
            align: this.getRenderProp('tooltipAlign'),
        });
    }
    componentDidRender() {
        if (this.ctaRef.el) {
            this.tooltipBehavior.syncListeners(undefined, this.ctaRef.el, true);
        }
    }
    disconnectedCallback() {
        if (this.unsubscribeOnLocationChange) {
            this.unsubscribeOnLocationChange();
            this.unsubscribeOnLocationChange = undefined;
        }
        this.tooltipBehavior.destroy();
    }
    getTooltipLabel() {
        const label = this.getRenderProp('label');
        if (typeof label === 'string' && label.length > 0) {
            return label;
        }
        const href = this.getRenderProp('href');
        return typeof href === 'string' ? href : '';
    }
    applyLabel(value) {
        labelWithExpertSlotProp.apply(value, (v) => {
            this.setRenderProp('label', v);
            this.setState('expertSlot', value === '');
            this.tooltipBehavior.watchLabel(this.getTooltipLabel());
        });
    }
    applyTooltipAlign(value) {
        tooltipAlignProp.apply(value, (v) => {
            this.setRenderProp('tooltipAlign', v);
            this.tooltipBehavior.watchAlign(v);
        });
    }
    async focus(options) { }
    async click() { }
    render() {
        return (h(LinkFC, { key: 'e7be771533126b9ee76a64a4b6f611461ce17bca', accessKey: this.getRenderProp('accessKey'), ariaControls: this.getRenderProp('ariaControls'), ariaCurrent: this.ariaCurrent, ariaCurrentValue: this.getRenderProp('ariaCurrentValue'), ariaDescription: this.getRenderProp('ariaDescription'), ariaDescriptionId: this.ariaDescriptionId, ariaExpanded: this.getRenderProp('ariaExpanded'), ariaOwns: this.getRenderProp('ariaOwns'), customClass: this.getRenderProp('customClass'), disabled: this.getRenderProp('disabled'), download: this.getRenderProp('download'), handleAnchorClick: this.handleAnchorClick, hideLabel: this.getRenderProp('hideLabel'), href: this.getRenderProp('href'), icons: this.getRenderProp('icons'), inline: this.getRenderProp('inline'), label: this.getRenderProp('label'), on: this.getRenderProp('on'), refAnchor: this.setAnchorRef, refTooltip: this.tooltipBehavior.setTooltipElementRef, role: this.getRenderProp('role'), shortKey: this.getRenderProp('shortKey'), tabIndex: this.getRenderProp('tabIndex'), target: this.getRenderProp('target'), tooltipAlign: this.getRenderProp('tooltipAlign'), variant: this.getRenderProp('variant'), expertSlot: this.expertSlot }));
    }
    watchAccessKey(value) {
        accessKeyProp.apply(value, (v) => this.setRenderProp('accessKey', v));
    }
    watchAriaCurrentValue(value) {
        ariaCurrentValueProp.apply(value, (v) => this.setRenderProp('ariaCurrentValue', v));
    }
    watchAriaControls(value) {
        ariaControlsProp.apply(value, (v) => this.setRenderProp('ariaControls', v));
    }
    watchAriaDescription(value) {
        ariaDescriptionProp.apply(value, (v) => this.setRenderProp('ariaDescription', v));
    }
    watchAriaExpanded(value) {
        ariaExpandedProp.apply(value, (v) => this.setRenderProp('ariaExpanded', v));
    }
    watchAriaOwns(value) {
        ariaOwnsProp.apply(value, (v) => this.setRenderProp('ariaOwns', v));
    }
    watchCustomClass(value) {
        customClassProp.apply(value, (v) => this.setRenderProp('customClass', v));
    }
    watchDisabled(value) {
        disabledProp.apply(value, (v) => this.setRenderProp('disabled', v));
    }
    watchDownload(value) {
        downloadProp.apply(value, (v) => this.setRenderProp('download', v));
    }
    watchHideLabel(value) {
        hideLabelProp.apply(value, (v) => this.setRenderProp('hideLabel', v));
    }
    watchHref(value) {
        hrefProp.apply(value, (v) => this.setRenderProp('href', v));
    }
    watchIcons(value) {
        spanIconsProp.apply(value, (v) => this.setRenderProp('icons', v));
    }
    watchInline(value) {
        inlineProp.apply(value, (v) => this.setRenderProp('inline', v));
    }
    watchLabel(value) {
        this.applyLabel(value);
    }
    watchOn(value) {
        linkCallbacksProp.apply(value, (v) => this.setRenderProp('on', v));
    }
    watchRole(value) {
        linkRoleProp.apply(value, (v) => this.setRenderProp('role', v));
    }
    watchShortKey(value) {
        shortKeyProp.apply(value, (v) => this.setRenderProp('shortKey', v));
    }
    watchTabIndex(value) {
        tabIndexProp.apply(value, (v) => this.setRenderProp('tabIndex', v));
    }
    watchTarget(value) {
        linkTargetProp.apply(value, (v) => this.setRenderProp('target', v));
    }
    watchTooltipAlign(value) {
        this.applyTooltipAlign(value);
    }
    watchVariant(value) {
        variantProp.apply(value, (v) => this.setRenderProp('variant', v));
    }
    get host() { return getElement(this); }
    static get watchers() { return {
        "_accessKey": ["watchAccessKey"],
        "_ariaCurrentValue": ["watchAriaCurrentValue"],
        "_ariaControls": ["watchAriaControls"],
        "_ariaDescription": ["watchAriaDescription"],
        "_ariaExpanded": ["watchAriaExpanded"],
        "_ariaOwns": ["watchAriaOwns"],
        "_customClass": ["watchCustomClass"],
        "_disabled": ["watchDisabled"],
        "_download": ["watchDownload"],
        "_hideLabel": ["watchHideLabel"],
        "_href": ["watchHref"],
        "_icons": ["watchIcons"],
        "_inline": ["watchInline"],
        "_label": ["watchLabel"],
        "_on": ["watchOn"],
        "_role": ["watchRole"],
        "_shortKey": ["watchShortKey"],
        "_tabIndex": ["watchTabIndex"],
        "_target": ["watchTarget"],
        "_tooltipAlign": ["watchTooltipAlign"],
        "_variant": ["watchVariant"]
    }; }
};
__decorate([
    directFocus('ctaRef')
], KolLinkWc.prototype, "focus", null);
__decorate([
    directClick('ctaRef')
], KolLinkWc.prototype, "click", null);

export { KolLinkWc as kol_link_wc };
//# sourceMappingURL=kol-link-wc.entry.js.map
